
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {UYAP_ENGEL_METINLERI} from '@/utils/uyapEngel';

/**
 * UYAP insan doğrulaması istediğinde BİR kez gösterilen uyarı penceresi (DEV-3572, SOZLESME §8.1 #15-17).
 *
 * `DevreKesiciDialog` iskeleti: persistent, `v-model` bayrağı. UYAP'ın metni DÜZ METİN olarak (`v-html` YOK) tırnak
 * içinde gösterilir. "Anladım" YALNIZ pencereyi kapatır (şerit ve kapı kalır). "Yeniden denemeye izin ver" ONAYSIZ
 * tek eylemdir (SOZLESME §13.7); kilit kalkınca (`uyapEngeliPanelAktif` false) pencere kendiliğinden kapanır.
 * UYAP'ın uyarıyı nasıl kaldırdığını bilmiyoruz: metinde "doğrulamayı şöyle yapın" talimatı YOK.
 */
@Component({})
export default class UyapEngeliDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly value!: boolean;

  izinVeriliyor = false;
  metinler = UYAP_ENGEL_METINLERI;

  get acik(): boolean {
    return this.value;
  }

  set acik(v: boolean) {
    if (!v) this.kapat();   // persistent: yalnız düğmelerden
  }

  get panelAktif(): boolean {
    return this.$store.getters.uyapEngeliPanelAktif === true;
  }

  get uyapMetni(): string {
    const kayit = this.$store.getters.uyapEngeliPanel;
    return kayit && kayit.metin ? kayit.metin : '';
  }

  @Watch('panelAktif')
  onPanelAktif(aktif: boolean) {
    if (!aktif && this.value) this.kapat();
  }

  /** "Anladım": YALNIZ pencere kapanır; şerit ve kapı kalır. */
  kapat() {
    this.$emit('input', false);
  }

  /** pencereyi kapatmaz */
  uyapiAc() {
    this.$socket.client.emit('openUyapWindow');
  }

  async izinVer() {
    if (this.izinVeriliyor) return;
    this.izinVeriliyor = true;
    try {
      await this.$store.dispatch('uyapEngeliniKaldir');   // pencere watcher ile kapanır
    } finally {
      this.izinVeriliyor = false;
    }
  }
}
